module.exports = __webpack_public_path__ + "fonts/NeutraTextTF-BoldItalic.fa7af548c9bb8d1c36b00f70aab9dcb7.otf";